import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../StudentCard.css";

class Parents extends Component {
  render() {
    const { classes, student } = this.props;
    return (
      <div className={classes.navRoot}>
        <div className={classes.navContent}>
          <h3>Parent's Information</h3>
          {student.father && (
            <Fragment>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Father's Name</b>
                <div>{student.father.name}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Father's Phone Number</b>
                <div>{student.father.phoneNo}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Father's Email Address</b>
                <div>{student.father.email}</div>
              </ListItem>
            </Fragment>
          )}
          <br />
          {student.mother && (
            <Fragment>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Mother's Name</b>
                <div>{student.mother.name}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Mother's Phone Number</b>
                <div>{student.mother.phoneNo}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Mother's Email Address</b>
                <div>{student.mother.email}</div>
              </ListItem>
            </Fragment>
          )}
          <br />
          {student.guardian && (
            <Fragment>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Guardian's Name</b>
                <div>{student.guardian.name}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}> Relation</b>
                <div>{student.guardian.relation}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Guardian's Phone Number</b>
                <div>{student.guardian.phoneNo}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Guardian's Email Address</b>
                <div>{student.guardian.email}</div>
              </ListItem>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(Parents);
